import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query/src/types';

import { getDefaultValues } from 'api/defaultValues';
import { ETripEvent } from 'detailsv2/structure';

import { PendingPage } from '../../useDefaultValues/types';
import * as types from './types';

export const useTripEventDefaultValuesQuery = (
  attachedPage?: PendingPage,
  eventType?: ETripEvent,
  options?: UseQueryOptions<types.TripEvemtDefaultValuesQueryRes>,
) => {
  const pageId = attachedPage?.id;
  const pageName = attachedPage?.name;

  return useQuery<types.TripEvemtDefaultValuesQueryRes>(
    ['defaultTripEventValues', pageId, pageName],
    () => getDefaultValues(eventType, pageId, pageName),
    {
      ...options,
      enabled: !!pageId || !!pageName,
    },
  );
};
